import type { ReactElement, ReactNode } from 'react';
import { useGamificationFeatureEnabled } from '@/hooks/data/config';

type GamificationFeatureGateProps = {
  children: ReactNode;
};

/** Renders children only when `features.gamification` is true. */
export function GamificationFeatureGate({ children }: GamificationFeatureGateProps): ReactElement | null {
  const enabled = useGamificationFeatureEnabled();
  if (!enabled) {
    return null;
  }
  return <>{children}</>;
}
